<template>
  <a-drawer width="40%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="brandcode" >
        <span slot="label" >
          <a-tooltip>
            品牌编码<template slot="title">品牌编码</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.brandcode" disabled :maxLength="50" placeholder="品牌背景图" />
      </a-form-model-item>
      <a-form-model-item label="品牌背景图" prop="carouselImages">
        <OssUploadSingle v-model="form.carouselImages" type="img" :maxSize="200"></OssUploadSingle>
        <span>推荐尺寸 750 * 1500</span>
      </a-form-model-item>
<!--      <a-form-model-item prop="remark" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            备注<template slot="title">备注</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.remark" :placeholder="'请输入备注'" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->

      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {mapGetters} from 'vuex'
import { getCarouselByBrandCode, addCarBrandCarousel, updateCarBrandCarousel } from '@/api/carConfig/carBrandCarousel'
import OssUploadMulti from "@/components/OssUploadMulti";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";

export default {
  name: 'CarouselForm',
  props: {
  },
  components: {
    OssUploadSingle,
    OssUploadMulti
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '编辑轮播图',
      previewImageVisible: false,
      previewUrl: '',
      loading: false,
      // 表单参数
      form: {
        id: null,
        brandcode: null,
        carouselImages: null,
        remark: null,
      },
      open: false,
      rules: {
        brandcode: [
          { required: true, message: '品牌编码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        brandcode: null,
        carouselImages: null,
        remark: null,
      }
      // 重置文件列表为空数组
      this.fileList = []
      this.loading = false
    },
    getUidRandom() {
      return Math.round(Math.random() * 80 + 20)
    },
    /** 打开编辑弹窗 */
    handleEdit(brandcode) {
      this.reset()
      this.form.brandcode = brandcode
      this.open = true
      this.formTitle = '编辑轮播图'
      // 获取已有的轮播图数据
      getCarouselByBrandCode(brandcode).then(response => {
        if (response.data) {
          //回显出轮播图
          // var advertImgList = response.data.carouselImages == null || response.data.carouselImages === '' ? [] : response.data.carouselImages.split(',')
          // for (var i = 0; i < advertImgList.length; i++) {
          //   this.form.carouselImages = []
          //   this.form.carouselImages.push({status: 'done', url: advertImgList[i], uid: this.getUidRandom(), name: advertImgList[i]})
          // }
          // console.log('this.form.carouselImages:'+this.form.carouselImages)
          this.form = response.data
        }
      }).catch(() => {
        // 如果没有找到数据，不处理，使用空表单
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 将文件列表中的URL转换为逗号分隔的字符串
         // this.form.carouselImages = this.form.carouselImages.join(',')
          this.submitLoading = true
          const message = '保存成功'
          // 根据是否有id判断是新增还是修改
          const apiCall = this.form.id ? updateCarBrandCarousel : addCarBrandCarousel
          apiCall(this.form).then(response => {
            this.$message.success(message, 3)
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>

<style scoped>
.upload-container {
  width: 100%;
}
.upload-tip {
  margin-top: 8px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}
.bottom-control {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
</style>
